function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0H196V196H0V0Z",
  fill: "#D2D1D8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M137.555 55.5977H58.4488C52.9954 55.5977 48.5605 60.3522 48.5605 66.1986V129.804C48.5605 135.651 52.9954 140.405 58.4488 140.405H137.555C143.009 140.405 147.443 135.651 147.443 129.804V66.1986C147.443 60.3522 143.009 55.5977 137.555 55.5977ZM70.8092 71.4991C72.7761 71.4991 74.6624 72.3368 76.0532 73.8278C77.4441 75.3189 78.2254 77.3412 78.2254 79.4498C78.2254 81.5585 77.4441 83.5808 76.0532 85.0718C74.6624 86.5629 72.7761 87.4005 70.8092 87.4005C68.8423 87.4005 66.9559 86.5629 65.5651 85.0718C64.1743 83.5808 63.393 81.5585 63.393 79.4498C63.393 77.3412 64.1743 75.3189 65.5651 73.8278C66.9559 72.3368 68.8423 71.4991 70.8092 71.4991ZM98.002 124.504H63.393L83.1695 98.0015L90.5858 108.602L105.418 87.4005L132.611 124.504H98.002Z",
  fill: "#A6A3B1"
});

var SvgDefaultCoverimage = function SvgDefaultCoverimage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDefaultCoverimage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/default_coverimage.9d060499.svg";
export { ForwardRef as ReactComponent };